<template>
  <v-form
    ref="form"
    v-model="isFormValid"
    :disabled="loading"
    @submit.prevent="() => submitForm()"
  >
    <v-container fluid class="pa-0">
      <v-row>
        <v-col cols="12">
          <password-field
            label="Senha"

            name="password"
            required

            v-model="formFields.password"
            :rules="[vRules.requiredField]"
          />
        </v-col>

        <v-col cols="12">
          <password-field
            label="Confirmar senha"

            name="password-confirmation"
            required

            v-model="formFields.passwordConfirmation"
            :rules="[vRules.requiredField]"
            :error-messages="passwordConfirmationErrorBag"
          />
        </v-col>
      </v-row>

      <v-row dense justify="space-between">
        <v-col cols="12" sm="auto" order-sm="2">
          <v-btn
            block
            color="primary"
            type="submit"

            :loading="loading"
            :disabled="!isFormValid"
          >
            Redefinir
          </v-btn>
        </v-col>

        <v-col cols="12" sm="auto" order-sm="1" class="d-flex align-center">
          <v-btn
            text
            block
            color="error"

            :disabled="loading"
            to="/login"
          >
            Voltar
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
  </v-form>
</template>

<script>
import { requiredField } from '@/utils/validators';
import PasswordField from '@/components/PasswordField.vue';

export default {
  name: 'PasswordResetForm',

  components: {
    PasswordField,
  },

  props: {
    loading: {
      type: Boolean,
      default: false,
    },
  },

  data: () => ({
    isFormValid: false,

    formFields: {
      password: '',
      passwordConfirmation: '',
    },

    vRules: {
      requiredField,
    },
  }),

  computed: {
    passwordConfirmationErrorBag: (vm) => {
      const errorBag = [];
      const { password, passwordConfirmation } = vm.formFields;

      if (passwordConfirmation && password !== passwordConfirmation) {
        errorBag.push('As senhas digitas devem ser iguais.');
      }

      return errorBag;
    },
  },

  methods: {
    submitForm() {
      this.$emit('submit', { ...this.formFields });
    },
  },
};
</script>
